import JSZIP from 'jszip'
import { saveAs } from 'file-saver'
import Axios from 'axios'

export const downloadFile = (url, fileName = false) => {
  const a = document.createElement('a')
  if (fileName) {
    a.download = fileName
  }
  a.href = url
  a.style.display = 'none'
  document.body.appendChild(a)
  a.click()
  a.parentNode.removeChild(a)
}

export const downloadFileWithNewFilename = (url, fileName = false) => {
  const xhr = new XMLHttpRequest()
  xhr.open('GET', `${url}`, true)
  xhr.responseType = 'blob'
  xhr.onload = e => {
    if (e.currentTarget.status === 200) {
      const blob = e.currentTarget.response
      const blobUrl = window.URL.createObjectURL(blob)
      downloadFile(blobUrl, fileName)
    }
  }
  xhr.send()
}

export const zipFilesFromUrls = async (files, zipName = 'files') => {
  const blobs = []
  for (const file of files) {
    const res = await Axios.get(file.url, { responseType: 'blob' }).catch(e => e.response)
    blobs.push({ blob: res.data, fileName: file.name })
  }
  const zip = new JSZIP()
  for (const blob of blobs) {
    zip.file(blob.fileName, blob.blob)
  }
  zip.generateAsync({ type: 'blob' })
    .then(content => saveAs(content, `${zipName}.zip`))
}
